import { render, staticRenderFns } from "./BenevolentVolume.vue?vue&type=template&id=d826d7e0"
import script from "./BenevolentVolume.vue?vue&type=script&lang=js"
export * from "./BenevolentVolume.vue?vue&type=script&lang=js"
import style0 from "./BenevolentVolume.vue?vue&type=style&index=0&id=d826d7e0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports